import { ImportFileClearForm } from "./import-file-clear-form";
import { ImportFileClearHandler } from "./import-file-clear-handler";
import { ImportFileClearListener } from "./import-file-clear-listener";

export class ImportFileClearSetup {
    public static init(root: HTMLElement): void {
        if (root.dataset.importFileClearInit === "1") return;
        root.dataset.importFileClearInit = "1";

        const form = new ImportFileClearForm(root);
        const input = form.getInput();
        const button = form.getClearButton();
        if (!input || !button) return;

        const handler = new ImportFileClearHandler();
        handler.applyVisibility(input, button);

        const listener = new ImportFileClearListener(handler);
        listener.register(input, button);
    }
}
